import React, { useEffect, useState } from 'react'
import HOC from '../../components/HOC/HOC'
import track from '../../css/style.module.css'


import { BaseUrl, getAuthHeaders } from '../../components/BaseURl/BaseUrl'
import { Link } from 'react-router-dom'
import axios from 'axios'
import MapliveLocationStaff from '../../components/Map/MapliveLocationStaff'

const TrackEmployee = () => {
  const [locationdata, setLoctionData] = useState([]);

  useEffect(() => {
    let isMounted = true;

    const fetchLocationData = async () => {
      try {
        const response = await axios.get(
          `${BaseUrl}api/v1/profile/getAllStaff`,
          getAuthHeaders()
        );

        if (isMounted) {
          // Extract location data
          const locations = response.data.data.map(item => ({
            latitude: item.location.coordinates[0],
            longitude: item.location.coordinates[1],
            staffId: item._id,
            staffName: item.firstName,
          }));

          // Set location data
          setLoctionData(locations);
          console.log(locations, "kjgdja")
        }
      } catch (error) {
        console.error('Error fetching location data:', error);
      }
    };


    fetchLocationData();

    return () => {
      isMounted = false;
    };
  }, []);


  const routeMapping = {
    Registered: "/staff-management/registered",
    'Active Employee': "/staff-management/active-employee",
    'Track Employee': "/staff-management/track-employee",
  };

  return (
    <>
      <div className={track.jobmanagementCotainer}>
        <div className={track.jobtoppart}>
          <div className={track.pagetitle}>
            <h6>User Management</h6>
          </div>
        </div>
        <div className={track.jobselectcontainer}>
          <div className={track.jobStatusContainer}>
            {['Registered', 'Active Employee', 'Track Employee'].map((item, index) => (
              <Link key={index} to={routeMapping[item]} className={track.link}>
                <p
                  className={
                    item === 'Track Employee'
                      ? track.jobOptionTrueactive
                      : track.jobOptionnotactive
                  }
                >
                  {item}
                </p>
              </Link>
            ))}
          </div>
        </div>


        <div className={track.trackcontainer}>
          <div className={track.tracktop}>
            <h6>Employee Live Location</h6>
            <div className={track.tracksitestatus}>
              <div className={track.tracksitestatus1}>
                <div className={track.tracksitecolor1}>

                </div>
                <p>Job Assigned</p>
              </div>
              <div className={track.tracksitestatus1}>
                <div className={track.tracksitecolor1} style={{ background: '#9747FF' }}>

                </div>
                <p>Not Assigned</p>
              </div>
              <div className={track.tracksitestatus1}>
                <div className={track.tracksitecolor1} style={{ background: '#FFA800' }}>

                </div>
                <p>On the way to destination</p>
              </div>
            </div>
          </div>
          <div className={track.trackmap}>
            <MapliveLocationStaff locations={locationdata} />


          </div>
        </div>
      </div>
    </>
  )
}

export default HOC(TrackEmployee)